var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"important-message"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"exclamation-triangle"}}),_vm._v(" "+_vm._s(_vm.appSettings.school_app_important_msg)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }